var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,{tag:"component",staticClass:"dropdown-item",attrs:{"to":_vm.to},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.closeNav($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }